module.exports = __webpack_public_path__ + "img/legalab.0a4dfba7.png";